<template>
	<div>
		<div v-if="!loaded" class="text-center">
			<loader class="mt-50 mb-50"> </loader>
		</div>
		<div v-else class="p-20">
			<div>
				<bar-chart v-if="loaded" :key="chartKey" :chartdata="chartdata" :options="options" />
			</div>
		</div>
	</div>
</template>

<script>
import BarChart from './Chart.vue';
import Loader from '@/components/_Loaders';
import { AGING_BALANCE, AGING_BALANCE_RECIPIENT } from '@/gql';
import { mapGetters } from 'vuex';
import Logging from '@/logging';
const { addDays, subDays, formatISO } = require('date-fns');

const currentDate = new Date();
const todayMinus30 = subDays(currentDate, 30);
const todayMinus60 = subDays(currentDate, 60);
const todayMinus90 = subDays(currentDate, 90);

export default {
	components: {
		BarChart,
		Loader
	},
	props: {
		recipient: { type: String, default: () => undefined },
		dateRange: { type: Array, default: () => undefined }
	},
	data() {
		return {
			chartKey: Math.ceil(Math.random() * 100000000000),
			loaded: false,
			chartdata: {},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					yAxes: [
						{
							ticks: {
								suggestedMin: 0
							}
						}
					]
				}
			}
		};
	},
	computed: {
		...mapGetters(['selectedParticipantStore', 'selectedLegalEntityStore'])
	},
	watch: {
		selectedParticipantStore() {
			if (this.selectedParticipantStore) {
				this.fetch();
			}
		},
		dateRange() {
			this.fetch();
		}
	},
	created() {
		if (this.selectedParticipantStore) {
			this.fetch();
		}
	},
	methods: {
		async fetch() {
			let agingVars;
			let gqlQuery;
			if (this.recipient) {
				agingVars = {
					participant: this.selectedParticipantStore,
					recipient: this.recipient,
					today: formatISO(currentDate),
					today_minus_30: formatISO(todayMinus30),
					today_minus_60: formatISO(todayMinus60),
					today_minus_90: formatISO(todayMinus90)
				};
				gqlQuery = AGING_BALANCE_RECIPIENT;
			} else {
				agingVars = {
					participant: this.selectedParticipantStore,
					legal_entity: this.selectedLegalEntityStore,
					today: formatISO(currentDate),
					today_minus_30: formatISO(todayMinus30),
					today_minus_60: formatISO(todayMinus60),
					today_minus_90: formatISO(todayMinus90),
					issue_date_from: this.dateRange[0],
					issue_date_until: this.dateRange[1]
				};
				gqlQuery = AGING_BALANCE;
			}
			try {
				const result = await this.$apollo.query({
					query: gqlQuery,
					variables: agingVars,
					fetchPolicy: 'no-cache'
				});
				this.loaded = true;
				// console.log(result);
				let agingBalanceData = [];
				for (const key of Object.keys(result.data)) {
					agingBalanceData.push(result.data[key].aggregate.sum.open_amount);
				}

				this.chartdata = {
					labels: [`${this.$t('openNotOverdue')}`, 'DD30', 'DD60', 'DD90', 'DD90+'],
					datasets: [{ data: agingBalanceData, backgroundColor: '#ed6b1c', label: `${this.$t('OPEN')} (€)` }]
				};

				this.chartKey = Math.ceil(Math.random() * 100000000000);
			} catch (e) {
				this.loaded = true;
				Logging.error(e);
			}
		}
	}
};
</script>
<style></style>
